import { WrappedGroupDetailPage } from './lib/GroupDetail';
export * from './lib/components';
export default WrappedGroupDetailPage;
